import "./style.scss";

const ProjectResourceItem = ({ item, products }) => {

    const findProduct = (code) => {
        return products.find((product) => product.product_code === code).title || code;
    }

    const lineColor = () => {
        if (item.used / item.limit > 0.9) {
            return "var(--theme-resources-item-red)";
        }
        if (item.used / item.limit > 0.7) {
            return "var(--theme-resources-item-orange)";
        }
        return "var(--theme-resources-item-green)";
    };
    
    return (
        <div className="project-resource-item">
            <div className="project-resource-item_details">
                <span className="project-resource-item_details_title">
                    {findProduct(item.type)}
                </span>
                <span className="project-resource-item_details_value"
                    style={{ color: lineColor() }}>
                    {item.used} из {item.limit}
                </span>
            </div>
            <div className="project-resource-item_line">
                <div
                    className="project-resource-item_line_percentage"
                    style={{
                        width: `${((item.used > 0 ? item.used : 0.1) / item.limit) * 95}%`,
                        background: lineColor(),
                    }}></div>
            </div>
        </div>
    );
};

export default ProjectResourceItem;
